/* eslint-disable react/jsx-key */
import React, { Component } from 'react';
import FormGroup from '@mui/material/FormGroup';
import Text from '../Text.js';
import Modal from './Modal.js';
import * as Theme from '../../theme/index.js';
import { lsaOptions } from '../../services/constants.js';
import Icon from "@mui/material/Icon";
import { styled } from '@mui/system';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as localizationMaps from '../../localization/maps.js';
const FullScreenBlock = styled("div")(({
  theme
}) => ({
  display: 'block',
  [theme.breakpoints.down(750)]: {
    display: 'none'
  }
}));
const MobileColumn = styled("div")(({
  theme
}) => ({
  display: 'none',
  [theme.breakpoints.down(750)]: {
    display: 'block',
    width: '100%'
  }
}));

/**
 * @param classes
 * @returns {*}
 * @constructor
 */
class LsaCategoriesModal extends Component {
  state = {
    selectedItems: null
  };
  async componentDidMount() {
    let selectedItems = this.props.items || (await this.props.getItems());

    // if the items are not already categorized then categorize them
    if (!selectedItems || !selectedItems.Health) {
      selectedItems = await this._categorizeItems(selectedItems);
    }
    this.setState({
      selectedItems
    });
  }
  _categorizeItems = async items => {
    const data = {
      Health: [],
      Alternative: [],
      Cosmetic: [],
      Personal: [],
      FitnessAndSports: [],
      Other: []
    };
    if (!items) {
      return data;
    }

    // eslint-disable-next-line array-callback-return
    const promises = items.map(item => {
      if (lsaOptions.Health.includes(item)) {
        data.Health.push(item);
      } else if (lsaOptions.Alternative.includes(item)) {
        data.Alternative.push(item);
      } else if (lsaOptions.Cosmetic.includes(item)) {
        data.Cosmetic.push(item);
      } else if (lsaOptions.Personal.includes(item)) {
        data.Personal.push(item);
      } else if (lsaOptions.FitnessAndSports.includes(item)) {
        data.FitnessAndSports.push(item);
      } else {
        data.Other.push(item);
      }
    });
    await Promise.all(promises);
    return data;
  };
  render() {
    const {
      open,
      whitelabel = {}
    } = this.props;
    const {
      selectedItems
    } = this.state;
    if (!this.state.selectedItems) {
      return null;
    }
    const styles = {
      lsaOptionsTitleRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        borderBottom: `1px solid ${Theme.colors.lightGrey}`,
        marginTop: 20
      },
      lsaColumn: {
        width: '34%'
      },
      lsaOptionRow: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 20
      },
      lsaColumnMobileTitle: {
        width: '100%',
        borderBottom: `1px solid ${Theme.colors.lightGrey}`,
        marginTop: 20
      },
      lsaColumnMobile: {
        width: '100%',
        marginBottom: 20
      },
      itemBlock: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 15
      }
    };
    return /*#__PURE__*/React.createElement(Modal, {
      title: i18n.t(tokens.labels.spendingAccounts.lifestyleSpendingAccount),
      testid: "lsa-details-modal",
      open: open,
      onClose: this.props.close,
      loader: this.props.loader,
      large: true
    }, /*#__PURE__*/React.createElement(Text, {
      medium: true
    }, i18n.t(tokens.labels.lsaModal.seeBelowTaxableLSACategoriesCovered)), /*#__PURE__*/React.createElement(FullScreenBlock, null, /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionsTitleRow
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.lsaColumn
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true
    }, i18n.t(tokens.labels.health))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaColumn
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true
    }, i18n.t(tokens.labels.lsaModal.alternativePractitioner))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaColumn
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true
    }, i18n.t(tokens.labels.lsaModal.cosmetic)))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionRow
    }, /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Health.map(item => {
      if (selectedItems.Health.includes(item)) {
        return /*#__PURE__*/React.createElement("div", {
          style: styles.itemBlock
        }, /*#__PURE__*/React.createElement(Icon, {
          style: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue
          }
        }, "check_box"), /*#__PURE__*/React.createElement(Text, {
          mediumBold: true,
          medium: true,
          margin: "0 0 0 5px"
        }, localizationMaps.fromEnglish('benefits', item)));
      }
      return /*#__PURE__*/React.createElement("div", {
        style: styles.itemBlock
      }, /*#__PURE__*/React.createElement(Text, {
        mediumBold: true,
        medium: true,
        margin: "0 0 0 5px",
        color: Theme.colors.mediumLightGrey
      }, localizationMaps.fromEnglish('benefits', item)));
    })), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Alternative.map(item => {
      if (selectedItems.Alternative.includes(item)) {
        return /*#__PURE__*/React.createElement("div", {
          style: styles.itemBlock
        }, /*#__PURE__*/React.createElement(Icon, {
          style: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue
          }
        }, "check_box"), /*#__PURE__*/React.createElement(Text, {
          mediumBold: true,
          medium: true,
          margin: "0 0 0 5px"
        }, localizationMaps.fromEnglish('benefits', item)));
      }
      return /*#__PURE__*/React.createElement("div", {
        style: styles.itemBlock
      }, /*#__PURE__*/React.createElement(Text, {
        mediumBold: true,
        medium: true,
        margin: "0 0 0 5px",
        color: Theme.colors.mediumLightGrey
      }, localizationMaps.fromEnglish('benefits', item)));
    })), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Cosmetic.map(item => {
      if (selectedItems.Cosmetic.includes(item)) {
        return /*#__PURE__*/React.createElement("div", {
          style: styles.itemBlock
        }, /*#__PURE__*/React.createElement(Icon, {
          style: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue
          }
        }, "check_box"), /*#__PURE__*/React.createElement(Text, {
          mediumBold: true,
          medium: true,
          margin: "0 0 0 5px"
        }, localizationMaps.fromEnglish('benefits', item)));
      }
      return /*#__PURE__*/React.createElement("div", {
        style: styles.itemBlock
      }, /*#__PURE__*/React.createElement(Text, {
        mediumBold: true,
        medium: true,
        margin: "0 0 0 5px",
        color: Theme.colors.mediumLightGrey
      }, localizationMaps.fromEnglish('benefits', item)));
    }))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionsTitleRow
    }, /*#__PURE__*/React.createElement("div", {
      style: styles.lsaColumn
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true
    }, i18n.t(tokens.labels.lsaModal.personal))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaColumn
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true
    }, i18n.t(tokens.labels.lsaModal.fitnessAndSports))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaColumn
    }, /*#__PURE__*/React.createElement(Text, {
      bold: true,
      medium: true
    }, i18n.t(tokens.labels.account.other)))), /*#__PURE__*/React.createElement("div", {
      style: styles.lsaOptionRow
    }, /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Personal.map(item => {
      if (selectedItems.Personal.includes(item)) {
        return /*#__PURE__*/React.createElement("div", {
          style: styles.itemBlock
        }, /*#__PURE__*/React.createElement(Icon, {
          style: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue
          }
        }, "check_box"), /*#__PURE__*/React.createElement(Text, {
          mediumBold: true,
          medium: true,
          margin: "0 0 0 5px"
        }, localizationMaps.fromEnglish('benefits', item)));
      }
      return /*#__PURE__*/React.createElement("div", {
        style: styles.itemBlock
      }, /*#__PURE__*/React.createElement(Text, {
        mediumBold: true,
        medium: true,
        margin: "0 0 0 5px",
        color: Theme.colors.mediumLightGrey
      }, localizationMaps.fromEnglish('benefits', item)));
    })), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.FitnessAndSports.map(item => {
      if (selectedItems.FitnessAndSports.includes(item)) {
        return /*#__PURE__*/React.createElement("div", {
          style: styles.itemBlock
        }, /*#__PURE__*/React.createElement(Icon, {
          style: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue
          }
        }, "check_box"), /*#__PURE__*/React.createElement(Text, {
          mediumBold: true,
          medium: true,
          margin: "0 0 0 5px"
        }, localizationMaps.fromEnglish('benefits', item)));
      }
      return /*#__PURE__*/React.createElement("div", {
        style: styles.itemBlock
      }, /*#__PURE__*/React.createElement(Text, {
        mediumBold: true,
        medium: true,
        margin: "0 0 0 5px",
        color: Theme.colors.mediumLightGrey
      }, localizationMaps.fromEnglish('benefits', item)));
    })), /*#__PURE__*/React.createElement(FormGroup, {
      sx: styles.lsaColumn
    }, lsaOptions.Other.map(item => {
      if (selectedItems.Other.includes(item)) {
        return /*#__PURE__*/React.createElement("div", {
          style: styles.itemBlock
        }, /*#__PURE__*/React.createElement(Icon, {
          style: {
            color: whitelabel.primaryColor || Theme.colors.skyBlue
          }
        }, "check_box"), /*#__PURE__*/React.createElement(Text, {
          mediumBold: true,
          medium: true,
          margin: "0 0 0 5px"
        }, localizationMaps.fromEnglish('benefits', item)));
      }
      return /*#__PURE__*/React.createElement("div", {
        style: styles.itemBlock
      }, /*#__PURE__*/React.createElement(Text, {
        mediumBold: true,
        medium: true,
        margin: "0 0 0 5px",
        color: Theme.colors.mediumLightGrey
      }, localizationMaps.fromEnglish('benefits', item)));
    })))));
  }
}
export default LsaCategoriesModal;